export default {
    type: 'text',
    format: {},
    default: {
        logic: 'contains'
    },
    setting: {
        logic: ['contains']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Parts',
        category: ['User', 'Collection'],
        description: 'Has-parts and want-parts notes on the collection item.',
        summarise: {
            prefix: 'Parts contains'
        }
    },
    rules: {
        linked: ['collection_hasparts_text', 'collection_wantparts_text'],
        legacy: ['collection.parts']
    }
}
